import styled, { css } from 'styled-components'
import theme from 'theme_'
import { H2 } from 'components/Typography'
import Icon from '@mdi/react'

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const JobHeaderTitle = styled(H2)`
  color: ${theme.colors.menuDark};
  word-break: break-word;
`

export const JobHeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 24px;
`

export const StyledJobHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
  background: ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  padding: 16px 24px;
  margin-bottom: 16px;
`

export const JobHeaderLeft = styled.div`
  ${baseFlex};
`

export const JobHeaderRight = styled.div`
  ${baseFlex};
`

export const JobHeaderIcon = styled(Icon)`
  color: ${theme.colors.beachGrey};
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`
